"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const clsx = require("../../../../chunks/clsx-CBkIpawf.js");
const Modal_module = require("../../../../chunks/Modal.module-DOd1Y64p.js");
const ModalFooter = ({ children, className, ...props }) => {
  return /* @__PURE__ */ jsxRuntime.jsx("footer", { className: clsx.clsx(Modal_module.styles.modalFooter, className), ...props, children });
};
exports.ModalFooter = ModalFooter;
